import React, { useState, useEffect } from "react";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState([]);

  const axiosAPI = useAxios(); // Use the custom Axios instance

  const fetchDashboardData = async () => {
    setLoading(true); // Set loading state to true before fetching data
    try {
      const response = await axiosAPI.get("/api/dashboard/dashboard-counts");
      setDashboardData(response?.data?.data || {}); // Set the fetched data to state
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setDashboardData({});
    } finally {
      setLoading(false); // Set loading state to false after data is fetched
    }
  };

  // Fetch dashboard data when the component mounts
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // Ensure you are using empty array as fallback
const total_products = dashboardData?.total_products ?? 0;
const total_categories = dashboardData?.total_categories ?? 0;
const total_subcategories = dashboardData?.total_subcategories ?? 0;

const total_restaurants = dashboardData?.total_restaurants ?? 0;
const total_restaurant_cities = dashboardData?.total_restaurant_cities ?? 0;

const total_users = dashboardData?.total_users ?? 0;
const total_contributions = dashboardData?.total_contributions ?? 0;
const total_recipe_videos = dashboardData?.total_recipe_videos ?? 0;
  // Show Bootstrap spinner while loading
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="page-inner">
       <div className="row">

  {/* Total Products */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-success bubble-shadow-small">
              <i className="fas fa-box"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Products</p>
              <h4 className="card-title">{total_products}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Restaurants */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-primary bubble-shadow-small">
              <i className="fas fa-store"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Restaurants</p>
              <h4 className="card-title">{total_restaurants}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Contributions */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-warning bubble-shadow-small">
              <i className="fas fa-hand-holding-heart"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Contributions</p>
              <h4 className="card-title">{total_contributions}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Users */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-info bubble-shadow-small">
              <i className="fas fa-users"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Users</p>
              <h4 className="card-title">{total_users}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Restaurant Cities */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-secondary bubble-shadow-small">
             <i className="fas fa-globe"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Restaurant Cities</p>
              <h4 className="card-title">{total_restaurant_cities}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Categories */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-danger bubble-shadow-small">
              <i className="fas fa-list"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Categories</p>
              <h4 className="card-title">{total_categories}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Recipe */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-dark bubble-shadow-small">
              <i className="fas fa-utensils"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Recipe</p>
              <h4 className="card-title">{total_recipe_videos}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Total Subcategories */}
  <div className="col-sm-6 col-md-3">
    <div className="card card-stats card-round">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-icon">
            <div className="icon-big text-center icon-dark bubble-shadow-small">
              <i className="fas fa-sitemap"></i>
            </div>
          </div>
          <div className="col col-stats ms-3 ms-sm-0">
            <div className="numbers">
              <p className="card-category">Total Sub Categories</p>
              <h4 className="card-title">{total_subcategories}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
      </div>
    </div>
  );
};

export default Dashboard;
